"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaCosmWasmCw20Service = exports.Cw20MsgData = void 0;
var FirmaUtil_1 = require("./FirmaUtil");
var cosmwasm_1 = require("./firmachain/cosmwasm");
// staic util
var noFunds = [];
var Cw20MsgData = /** @class */ (function () {
    function Cw20MsgData() {
    }
    Cw20MsgData.getMsgDataTransfer = function (recipient, amount) {
        return JSON.stringify({
            "transfer": {
                recipient: recipient,
                amount: amount
            }
        });
    };
    Cw20MsgData.getMsgDataTransferFrom = function (owner, recipient, amount) {
        return JSON.stringify({
            "transfer_from": {
                owner: owner,
                recipient: recipient,
                amount: amount
            }
        });
    };
    Cw20MsgData.getMsgDataMint = function (recipient, amount) {
        return JSON.stringify({
            "mint": {
                recipient: recipient,
                amount: amount
            }
        });
    };
    Cw20MsgData.getMsgDataBurn = function (amount) {
        return JSON.stringify({
            "burn": {
                amount: amount
            }
        });
    };
    Cw20MsgData.getMsgDataBurnFrom = function (owner, amount) {
        return JSON.stringify({
            "burn_from": {
                owner: owner,
                amount: amount
            }
        });
    };
    Cw20MsgData.getMsgDataIncreaseAllowance = function (spender, amount, expires) {
        return JSON.stringify({
            "increase_allowance": {
                spender: spender,
                amount: amount,
                expires: expires
            }
        });
    };
    Cw20MsgData.getMsgDataDecreaseAllowance = function (spender, amount, expires) {
        return JSON.stringify({
            "decrease_allowance": {
                spender: spender,
                amount: amount,
                expires: expires
            }
        });
    };
    Cw20MsgData.getMsgDataUpdateMinter = function (new_minter) {
        return JSON.stringify({
            "update_minter": {
                new_minter: new_minter,
            }
        });
    };
    Cw20MsgData.getMsgDataUpdateMarketing = function (description, marketing, project) {
        return JSON.stringify({
            "update_marketing": {
                description: description,
                marketing: marketing,
                project: project
            }
        });
    };
    Cw20MsgData.getMsgDataUploadLogo = function (url) {
        return JSON.stringify({
            "upload_logo": {
                url: url
            }
        });
    };
    Cw20MsgData.getMsgDataSend = function (contract, amount, msg) {
        return JSON.stringify({
            "send": {
                contract: contract,
                amount: amount,
                msg: btoa(JSON.stringify(msg))
            }
        });
    };
    Cw20MsgData.getMsgDataSendFrom = function (contract, owner, amount, msg) {
        return JSON.stringify({
            "send_from": {
                contract: contract,
                owner: owner,
                amount: amount,
                msg: btoa(JSON.stringify(msg))
            }
        });
    };
    return Cw20MsgData;
}());
exports.Cw20MsgData = Cw20MsgData;
// class
var FirmaCosmWasmCw20Service = /** @class */ (function () {
    function FirmaCosmWasmCw20Service(config, cosmwasmService) {
        this.config = config;
        this.cosmwasmService = cosmwasmService;
    }
    // tx
    FirmaCosmWasmCw20Service.prototype.transfer = function (wallet, contractAddress, recipient, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransfer(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxTransfer = function (wallet, contractAddress, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransfer(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.transferFrom = function (wallet, contractAddress, owner, recipient, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransferFrom(owner, recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxTransferFrom = function (wallet, contractAddress, owner, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransferFrom(owner, recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.mint = function (wallet, contractAddress, recipient, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataMint(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxMint = function (wallet, contractAddress, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataMint(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.burn = function (wallet, contractAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurn(amount);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxBurn = function (wallet, contractAddress, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurn(amount);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.burnFrom = function (wallet, contractAddress, owner, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurnFrom(owner, amount);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxBurnFrom = function (wallet, contractAddress, owner, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurnFrom(owner, amount);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.increaseAllowance = function (wallet, contractAddress, spender, amount, expires, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataIncreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxIncreaseAllowance = function (wallet, contractAddress, spender, amount, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataIncreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.decreaseAllowance = function (wallet, contractAddress, spender, amount, expires, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataDecreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxDecreaseAllowance = function (wallet, contractAddress, spender, amount, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataDecreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.updateMinter = function (wallet, contractAddress, new_minter, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMinter(new_minter);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxUpdateMinter = function (wallet, contractAddress, new_minter) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMinter(new_minter);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.updateMarketing = function (wallet, contractAddress, description, marketing, project, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMarketing(description, marketing, project);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxUpdateMarketing = function (wallet, contractAddress, description, marketing, project) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMarketing(description, marketing, project);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.uploadLogo = function (wallet, contractAddress, url, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUploadLogo(url);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxUploadLogo = function (wallet, contractAddress, url) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUploadLogo(url);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.send = function (wallet, contractAddress, targetContractAddress, amount, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSend(targetContractAddress, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxSend = function (wallet, contractAddress, targetContractAddress, amount, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSend(targetContractAddress, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.sendFrom = function (wallet, contractAddress, targetContractAddress, owner, amount, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSendFrom(targetContractAddress, owner, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getUnsignedTxSendFrom = function (wallet, contractAddress, targetContractAddress, owner, amount, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSendFrom(targetContractAddress, owner, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationSignAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, txRaw, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // gas
    FirmaCosmWasmCw20Service.prototype.getGasEstimationTransfer = function (wallet, contractAddress, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransfer(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationTransferFrom = function (wallet, contractAddress, owner, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataTransferFrom(owner, recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationMint = function (wallet, contractAddress, recipient, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataMint(recipient, amount);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationBurn = function (wallet, contractAddress, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurn(amount);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationBurnFrom = function (wallet, contractAddress, owner, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataBurnFrom(owner, amount);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationIncreaseAllowance = function (wallet, contractAddress, spender, amount, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataIncreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationDecreaseAllowance = function (wallet, contractAddress, spender, amount, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataDecreaseAllowance(spender, amount, expires);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationUpdateMinter = function (wallet, contractAddress, new_minter) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMinter(new_minter);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationUpdateMarketing = function (wallet, contractAddress, description, marketing, project) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUpdateMarketing(description, marketing, project);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationUploadLogo = function (wallet, contractAddress, logo) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataUploadLogo(logo);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationSend = function (wallet, contractAddress, targetContractAddress, amount, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSend(targetContractAddress, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getGasEstimationSendFrom = function (wallet, contractAddress, targetContractAddress, owner, amount, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw20MsgData.getMsgDataSendFrom(targetContractAddress, owner, amount, msg);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // query
    FirmaCosmWasmCw20Service.prototype.getBalance = function (contractAddress, address) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"balance\": { \"address\": \"" + address + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.balance];
                    case 2:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getTotalSupply = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"token_info\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.total_supply];
                    case 2:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getTokenInfo = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"token_info\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getMinter = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"minter\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getAllowance = function (contractAddress, owner, spender) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"allowance\": {\"owner\": \"" + owner + "\", \"spender\":\"" + spender + "\"}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getAllAllowances = function (contractAddress, owner, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_allowances\": {\"owner\": \"" + owner + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\"}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.allowances];
                    case 2:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getAllSpenderAllowances = function (contractAddress, spender, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_spender_allowances\": {\"spender\": \"" + spender + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\"}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.allowances];
                    case 2:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getAllAccounts = function (contractAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_accounts\": {\"limit\": " + limit + ", \"start_after\": \"" + start_after + "\"}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.accounts];
                    case 2:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getMarketingInfo = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"marketing_info\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw20Service.prototype.getDownloadLogo = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"download_logo\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaCosmWasmCw20Service;
}());
exports.FirmaCosmWasmCw20Service = FirmaCosmWasmCw20Service;
